import React, { FC, Suspense } from 'react';

import { useIntl } from 'react-intl';

import { IBarcode } from 'components/barcode';
import { LazyComponent, lazyWithNullFallback } from 'components/layout/util';
import { TimsRewardsDisclaimer } from 'components/tims-rewards-disclaimer';

import { MobileOnlyContent } from '../styled';

import { BarcodeContainer, ContentBlock, TimCardHeading } from './styled';

const Barcode: LazyComponent<IBarcode> = lazyWithNullFallback(() => import('components/barcode'));

interface ITimCardScanSectionProps {
  barcode: string | null;
}

export const TimCardScanSection: FC<ITimCardScanSectionProps> = ({ barcode }) => {
  const { formatMessage } = useIntl();

  return (
    <MobileOnlyContent>
      <ContentBlock margin="0">
        <TimCardHeading>{formatMessage({ id: 'scanToPayWithYourTimCard' })}</TimCardHeading>
        <Suspense fallback={null}>
          {!!barcode && (
            <BarcodeContainer>
              <Barcode value={barcode} />
            </BarcodeContainer>
          )}
        </Suspense>
        <TimsRewardsDisclaimer message={formatMessage({ id: 'scanForTimsRewardsBeforePaying' })} />
      </ContentBlock>
    </MobileOnlyContent>
  );
};

export default TimCardScanSection;
